module.exports = __webpack_public_path__ + "static/img/bg4.e36f847.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg4.png
// module id = fXWU
// module chunks = 0